import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import { useLabels } from '../../hooks/useLabels';
import { useEditorReturn } from '../../hooks/useEditorReturn';
import AssetSaleEditor from './AssetSaleEditor';

function NewAssetSale() {
	const { t } = useLabels();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const returnToParam = searchParams.get('returnTo');
	const { onReturn, returnLabel } = useEditorReturn();

	return (
		<EntityList>
			<Helmet>
				<title>{t('title.assetSale')}</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: t('entity.assetSale.plural'), to: '/AdminScreen/assetSales' },
					{ label: t('title.assetSale') },
				]}
				title={t('title.assetSale')}
				subtitle='Completá los datos para registrar la venta.'
			/>
			<AssetSaleEditor
				mode='create'
				onCancel={() => navigate('/AdminScreen/assetSales')}
				onReturn={onReturn}
				returnLabel={returnLabel}
				onSaved={(savedAssetSaleId) => {
					if (returnToParam) {
						// Resolved against our own origin so an absolute/protocol-relative
						// returnTo can't navigate off-site — only pathname+search are used.
						const target = new URL(returnToParam, window.location.origin);
						target.searchParams.set('assetSaleId', savedAssetSaleId);
						navigate(`${target.pathname}${target.search}`);
					} else {
						navigate(`/AdminScreen/assetSales/assetSale/${savedAssetSaleId}`);
					}
				}}
			/>
		</EntityList>
	);
}

export default NewAssetSale;
